import ReactDOM from 'react-dom';
import { isBrowser } from '@noths/polaris-client-utils';

export interface ErrorNotificationWrapper {
  children: JSX.Element | boolean;
}

export const ERROR_NOTIFICATION_TESTID = 'error-notification';

export const ErrorNotificationWrapper = ({ children }: ErrorNotificationWrapper) => {
  if (!isBrowser()) {
    return null;
  }

  const nothsPageWrapper = document.querySelector('#NOTHSPageWrapper');

  return nothsPageWrapper && ReactDOM.createPortal(children, nothsPageWrapper);
};
